module.exports = __webpack_public_path__ + "img/img_flag_pm.ce213946.png";